import { IconButton, Tooltip } from "@mui/material";
import SyncOutlinedIcon from "@mui/icons-material/SyncOutlined";
import { useSnackbar } from "notistack";
import { useSyncTranslationWordsMutation } from "@/admin/entities/translations";
import type { TranslationRow } from "../model/types";

export function SyncTranslationButton({
  translation,
}: {
  translation: TranslationRow;
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [syncWords, { loading }] = useSyncTranslationWordsMutation();

  if (translation.version === "latest") return null;

  const onClick = async () => {
    try {
      await syncWords({ variables: { id: translation.id } });
      enqueueSnackbar("Ключи синхронизированы", { variant: "success" });
    } catch (err) {
      enqueueSnackbar((err as Error).message, { variant: "error" });
    }
  };

  return (
    <Tooltip title="Синхронизировать ключи между языками">
      <span>
        <IconButton onClick={onClick} disabled={loading} size="small">
          <SyncOutlinedIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
}
